export class HealthUnitStruct {
    public idHealthUnit: number | null = null;
    public healthUnitName: string = '';
    public timeZoneValue: number | null = null;
    public loginTimeoutValue: number | null = null;
    public idReportSadtTemplate: number | null = null;
    public idProcedureSigtapCompetence: number | null = null;
    public listIdHealthUnitInGroup: number[] = [];
    public hasFacialBiometrics: boolean = false;
}